<template>
	<div class="modal-container ModalAddEditFunding">
		<div class="modal-header">Funding Details</div>
		<div class="modal-body">
			<fieldset :disabled="modal.isModalDisabled">
				<Panel
					title="Basic Info"
					class="gapped-fields"
				>
					<template #HeaderComponent>
						<div class="panel-buttons">
							<InputRichDropdown
								v-if="isNewFunding"
								v-model:saturn="selectedStoreFunding"
								:list="storeFundings"
								:valueMap="(pf: any) => pf"
								:display="(pf: any) => (pf.name ? pf.name : 'CUSTOM FUNDING')"
								@change="onStoreFundingSelected"
								nothingSelected="-- FUNDING Type --"
							>
							</InputRichDropdown>
						</div>
					</template>
					<div
						:style="$grid('1-1')"
						class="no-margin-grid"
					>
						<InputTextbox
							label="Name"
							v-model:saturn="funding.name"
							placeholder="Name"
							:disabled="modal.isModalDisabled || !selectedStoreFunding || !selectedStoreFunding.isEditableName"
						>
						</InputTextbox>
						<InputCurrency
							label="Amount"
							v-model:saturn="funding.amount"
							:precision="2"
							iconSide="left"
							@change="fundingChanged()"
							:disabled="modal.isModalDisabled || !selectedStoreFunding || !selectedStoreFunding.isEditableAmount"
						/>
						<InputTextbox
							label="Reference Number"
							v-model:saturn="funding.refNumber"
							placeholder="Reference Number"
							:disabled="modal.isModalDisabled || !selectedStoreFunding || !selectedStoreFunding.isEditableReferenceNumber"
						/>
						<InputRichDropdown
							label="Profit Flag"
							v-model:saturn="funding.profitFlag"
							:list="profitFlags"
							:valueMap="(pf: any) => pf.value"
							:display="(pf: any) => pf.text"
							nothingSelected="-- Select Value --"
							:disabled="modal.isModalDisabled || (isNewFunding && !selectedStoreFunding)"
						/>
					</div>
				</Panel>
			</fieldset>
		</div>
		<div class="modal-footer modal-footer-split">
			<div>
				<button
					class="button-error"
					@click="deleteFunding()"
					v-if="!isNewFunding"
				>
					Delete Funding Line
				</button>
			</div>
			<div>
				<button
					class="button-unwind ignore-all-locks"
					@click="cancel()"
				>
					Cancel
				</button>
				<button
					class="button-save"
					@click="save()"
					:disabled="modal.isModalDisabled || (isNewFunding && !selectedStoreFunding)"
				>
					Save
				</button>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	import { ref } from 'vue';
	import $modal from '@core/services/modal';
	import DropdownHelper from '@core/helpers/dropdown-helper';
	import FIMenu from '@core/classes/FIMenu';
	import { IBucketModalProps } from '@core/_interfaces/ComponentProps';
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import InputCurrency from '@core/components/InputCurrency.vue';
	import InputNumber from '@core/components/InputNumber.vue';
	import InputTextbox from '@core/components/InputTextbox.vue';
	import Panel from '@core/components/Panel.vue';
	import FIMenuFunding from '@core/classes/FIMenuFunding';
	import { StoreFunding } from '@core/classes/Store/StoreFunding';
	import AccountingHelper from '@/helpers/AccountingHelper';
	import util from '@core/services/util';

	export interface IProductsBucketModalProps extends IBucketModalProps {
		fimenu?: FIMenu;
		passedFunding?: FIMenuFunding;
		storeFundings?: StoreFunding[];
	}

	const { modal } = defineProps<{
		modal: IProductsBucketModalProps;
	}>();

	const isNewFunding = ref(modal.passedFunding == null);
	const profitFlags = ref(null);
	const selectedStoreFunding = ref<StoreFunding>(null);
	const storeFundings = ref<StoreFunding[]>([]);
	const accountingHelper = new AccountingHelper();

	storeFundings.value = modal.storeFundings.map((funding: Partial<StoreFunding>) => new StoreFunding(funding));

	profitFlags.value = DropdownHelper.getProfitFlags();

	const funding = ref<FIMenuFunding>(new FIMenuFunding(modal.passedFunding));
	const showDeleteButton = ref();

	function fundingChanged() {
		console.log('fundingChanged');
		funding.value = selectedStoreFunding.value.toDealFunding();
	}

	function cancel() {
		$modal.cancel();
	}

	async function save() {
		$modal.close({
			funding: funding.value,
			isDelete: false,
		});

		if (modal.fimenu.isAccountingFinalized()) {
			accountingHelper.addFundingAdjustment(modal.fimenu, funding.value);
		}
	}

	function deleteFunding() {
		const result = confirm('Are you sure you want to delete this funding line?');
		if (result) {
			$modal.close({
				funding: funding.value,
				isDelete: true,
			});
		}
	}

	function onStoreFundingSelected() {
		console.log('onStoreFundingSelected');
		if (!selectedStoreFunding.value) return;
		//ADDITION INFO
		funding.value = new FIMenuFunding({
			...selectedStoreFunding.value,
			id: util.getGuid(),
		});
	}
	//const validations = computed(() => ({
	//    funding: funding.value.validation() as any,
	//}));

	//const v$ = useVuelidate(validations, { funding });
</script>
<style scoped>
	.ModalAddEditFunding .panel.gapped-fields .panel-body {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.bucket-list {
		margin-left: 15px;
	}

	.bucket-list .bucket {
		align-items: center;
	}

	.bucket-type-title {
		height: 25px;
	}

	.taxline-tax-total-first {
		margin-top: 45px;
	}

	.taxline-tax-total {
		align-items: center;
		font-weight: bold;
	}

	.taxline-tax-total input {
		font-weight: bold;
	}

	.taxline-tax-header {
		text-align: right;
		font-weight: bold;
	}
</style>
